module.exports = __webpack_public_path__ + "static/media/Sharp-LCD-Specification-LS013B7DH05-12-17-19.4f9deb60.pdf";